import React from 'react'
import { Equipment } from '@/payload-types'
import { GridBlock } from '@/components'

interface EquipmentListProps {
  items: Equipment[]
}

function EquipmentList({ items }: Readonly<EquipmentListProps>) {
  return (
    <GridBlock
      blockType="grid"
      items={items.map((equipment) => ({
        relationTo: 'equipments' as const,
        value: equipment,
      }))}
    />
  )
}

export { EquipmentList }
